import { MessageCircle, MapPin, BadgeCheck, Wrench, GraduationCap } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { CallButton } from "@/components/CallButton";
import { WA, IMAGES, SOCIALS } from "@/content";

export default function Support() {
  return (
    <section id="soporte" data-testid="support-section" className="relative py-20 lg:py-28 bg-white overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="relative" data-testid="support-image-frame">
            <div
              aria-hidden="true"
              className="absolute -bottom-5 -right-5 h-full w-full rounded-[2rem] border-2 border-brand-orange/40"
            />
            <img
              src={IMAGES.lab}
              alt="Laboratorio de análisis veterinario con microscopio"
              className="relative rounded-[2rem] w-full h-[420px] object-cover shadow-xl"
              loading="lazy"
            />
            <div className="absolute -top-6 -left-4 sm:-left-8 glass border border-slate-200 rounded-2xl shadow-lg px-5 py-4" data-testid="support-experience-badge">
              <span className="font-display text-3xl font-extrabold text-brand-orange">+12</span>
              <span className="block text-xs font-bold text-slate-600 uppercase tracking-wider">
                años de experiencia
              </span>
            </div>
          </div>
        </Reveal>

        <div>
          <SectionHead
            eyebrow="Soporte técnico especializado"
            title="No solo te vendemos el equipo: lo mantenemos funcionando."
            sub="Hamburger Invitro es servicio técnico y venta de analizadores de diagnóstico in vitro. Detrás de cada EH8300 VET hay un ingeniero biomédico con más de 12 años de experiencia en hematología, química, electrolitos y coagulación."
          />

          <div className="mt-9 space-y-4">
            {[
              { icon: Wrench, t: "Mantenimiento preventivo y correctivo", d: "Planes de cuidado para todo el parque de analizadores de tu clínica." },
              { icon: BadgeCheck, t: "Soporte directo con quien instala tu equipo", d: "Sin call centers: hablas con el ingeniero que conoce tu analizador." },
              { icon: GraduationCap, t: "Acompañamiento post-venta real", d: "Capacitación continua para que tu personal saque el máximo provecho." },
            ].map((item, i) => (
              <Reveal key={item.t} delay={i * 0.08}>
                <div className="flex gap-4 items-start" data-testid={`support-item-${i}`}>
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brand-soft text-brand-orange">
                    <item.icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold text-brand-ink">{item.t}</h3>
                    <p className="text-sm text-slate-600 mt-1 leading-relaxed">{item.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.25}>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a
                href={WA.info}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="support-whatsapp-cta"
                className="btn-shine inline-flex items-center gap-2 rounded-full bg-brand-ink text-white font-bold text-sm px-7 py-4 hover:bg-brand-orange transition-colors duration-300"
              >
                <MessageCircle className="h-4 w-4" />
                Hablar con el ingeniero
              </a>
              <CallButton variant="light" testid="support-call-cta" className="!text-sm" />
              <span className="inline-flex items-center gap-2 text-sm font-bold text-slate-600 w-full" data-testid="support-location">
                <MapPin className="h-4 w-4 text-brand-orange" />
                Barranquilla, Colombia · Atendemos toda la ciudad
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
